import { render, staticRenderFns } from "./EditProgram.vue?vue&type=template&id=1d7b006b&scoped=true&lang=pug&"
import script from "./EditProgram.vue?vue&type=script&lang=js&"
export * from "./EditProgram.vue?vue&type=script&lang=js&"
import style0 from "./EditProgram.vue?vue&type=style&index=0&id=1d7b006b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7b006b",
  null
  
)

export default component.exports